import { render, staticRenderFns } from "./searchTeamCard.vue?vue&type=template&id=794abb54&scoped=true&"
import script from "./searchTeamCard.vue?vue&type=script&lang=js&"
export * from "./searchTeamCard.vue?vue&type=script&lang=js&"
import style0 from "./searchTeamCard.vue?vue&type=style&index=0&id=794abb54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794abb54",
  null
  
)

export default component.exports